@if (hasGaranti) {
  <mat-chip-option
    class="orange-bg"
    [matTooltip]="maxGarantiEndDate != null ? 'Garanti på anlæg/komp. frem til ' + maxGarantiEndDateString : ''"
    >
    <mat-icon svgIcon="obs-solid" class="white margin--right-xs"></mat-icon>
    Garanti på anlæg/komp.
  </mat-chip-option>
}
